export const isEmptyText = (node => (content: string) => {
  node.innerHTML = content;
  return node.innerText.trim().length === 0;
})(document.createElement("div"));
